import React, { useRef, useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Nutridiet.scss';
import nutridiet_img from './images/home_banner_new.png'
import headericon from './images/headericon.svg'
import follower from './images/follower.webp'
import saladPlateImage from './images/saladPlateImage.svg'
import benefitcard from './images/benefitcard.webp'
import Nutritionist from './images/Nutritionist.svg'
import Dietician from './images/Dietician.svg'
import insta from './images/insta.svg'
import fb from './images/fb.svg'
import footericon from './images/footericon.webp'
import phoneicon from './images/phone.svg'
import vector from './images/vector.svg'
import greenbackground from './images/greenbackground.svg'
import InnerNavComponent from "../../../Components/InnerNavComponent";
import nutri_diet_logo from './images/nutri_diet_logo.svg'
import nutri_diet_hero_wrapper from './images/nutri_diet_hero_wrapper.svg'
import right_fruit_1 from './images/right_fruit_1.webp'
import left_fruit_2 from './images/left_fruit_2.webp'
import left_image_3 from './images/left_image_3.webp'
import right_top_1 from './images/right_top_1.webp'
import right_2 from './images/right_2.webp'
import right_5 from './images/right_5.webp'
import frame_timeline_new from './images/frame_timeline_new.webp'
import timeline from './images/timeline.png'
import right_fruit_new_3 from './images/right_fruit_new_3.webp'
import SelectDropDown from '../../../Components/Select Dropdown';
import CommonBtn from '../../../Components/commonbtn';
import ReactGA from 'react-ga4';
import SubcriptionForm from '../../NutriDiet/Subscription';
import { Pagination, Scrollbar, A11y } from "swiper/modules";
import Vihar from './images/new_vihar.png'
import VICHAR from './images/new_vichaar.png'
import Ahar from './images/new_ahar.png'
import ACHAAR from './images/new_achaar.png'
import Vinita from './images/Vinita_new.jpg'
import Kreena from './images/Kreena_new.jpg'
import TYI_Mobile_v2 from './images/TYI_Mobile_v2.webp'
import frame_left_client from './images/frame_left_client.png'
import copy from './images/copy.svg'
import nutri_diet_mobile_footer_arrow from './images/nutri_diet_mobile_footer_arrow.svg'
import MessageReview from './MessageReview';
import ne_mobile_table from './images/ne_mobile_table.svg'
import mobile_arrow_down_line from './images/mobile_arrow_down_line.svg';



const NutriDietHero = () => {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);
  const swiperRef = useRef(null);
  const [price, setPrice] = useState()
  const [openForm1, setOpenForm1] = useState(false)
  const [openForm2, setOpenForm2] = useState(false)
  const [err, setErr] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0);
  const [plan, setPlan] = useState('')
  const [program, setProgram] = useState('')
  
  const [prevActiveIndex, setPrevActiveIndex] = useState(null);
  const [direction, setDirection] = useState("next");

  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);
  const [selectedDuration, setSelectedDuration] = useState('1 week');
  const [selectedCurrency, setSelectedCurrency] = useState('Living in India');
  const [expandedPrograms, setExpandedPrograms] = useState({});

  const openModal = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  const toggleAccordion = (programName) => {
    setExpandedPrograms(prev => ({
      ...prev,
      [programName]: !prev[programName]
    }));
  };

  // Function to get pricing based on selected currency
  const getPricingForCurrency = (duration, currency, program = null) => {
    // Special pricing for Clinical Plans
    if (program === "Clinical Plans") {
      const clinicalPricing = {
        '1 week': { inr: 0, usd: 0 },
        '1 month': { inr: 4999, usd: 50 },
        '3 months': { inr: 9999, usd: 80 },
        '6 months': { inr: 14999, usd: 150 }
      };
      
      if (duration === '1 week') {
        return "-";
      }
      
      if (currency === 'INR') {
        return `₹ ${clinicalPricing[duration].inr.toLocaleString()}`;
      } else {
        return `USD ${clinicalPricing[duration].usd}`;
      }
    }
    
    // Default pricing for other programs
    if (currency === 'INR') {
      return `₹ ${mobilePricing[duration].inr.toLocaleString()}`;
    } else {
      return `USD ${mobilePricing[duration].usd}`;
    }
  };


  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex);
    setPrevActiveIndex(activeIndex);
  };

  const Locate = {
    title: 'Contact us',
    color: 'white',
    menuColor: 'white',
    menuItems: [],
  }


  const highlightsData = [
    {
      category: 'Ahar',
      img: 'https://nispand.s3.ap-south-1.amazonaws.com/files/AAHAR-removebg-preview.png',
      subcategory: '(Diet & Nutrition)',
      title: '"Fuel for the Soul"',
      description: 'Emphasizing food as nourishment beyond just the body'
    },
    {
      category: 'Vihar',
      img: 'https://nispand.s3.ap-south-1.amazonaws.com/files/VIHAR-removebg-preview.png',
      subcategory: '(Lifestyle & Routine)',
      title: '"Flow of Life"',
      description: 'Capturing the essence of movement, relaxation, and daily habits'
    },
    {
      category: 'Aachar',
      img: `https://nispand.s3.ap-south-1.amazonaws.com/files/AACHAR-removebg-preview.png`,
      subcategory: '(Discipline & Conduct)',
      title: '"Rhythm of Actions"',
      description: 'Highlighting the impact of daily behavior and ethics'
    },
    {
      category: 'Vichar',
      img: 'https://nispand.s3.ap-south-1.amazonaws.com/files/VICHAR-removebg-preview.png',
      subcategory: '(Thoughts & Mindset)',
      title: '"Echoes of the Mind"',
      description: 'Reflecting on how thoughts shape our reality'
    }
  ];

  const reviews = [
    {
      id: 1,
      text: "A 24 year old client, presented with high bilirubin, Hair fall, and dandruff, came with a goal of fat loss and muscle gain",
      details: "\"It was great! Inclusion of fiber based foods and changing my meal times played a big role and now my weight has gone down from 83.3 to 79.6 and is still dropping! I've not lost any muscle in the process so that's great as well\""
    },
    {
      id: 2,
      text: "A 59 year old man with a history of Type 2 diabetes went through Angioplasty, experienced low energy levels, muscle wasting and deranged lipid levels, came with a goal of improving lipid profile, energy level and diabetes management. ",
      details: "Our three month long association with NutriDiet Clinic by The Yoga Institute has been  a wonderful experience. I want to take this opportunity to express our sincere gratitude for all the nutritional and dietary advice you have provided .Your personalised approach and encouragement have helped in adopting healthy eating  habits and making positive changes in our daily life Have noticed improvements in energy levels and overall well-being ,medication has been reduced after following this diet plan for the last 2 months.We truly appreciate the time you took to address our specific needs .Our entire family has adopted this nutrient rich diet to have a healthy and balanced life.Your expert guidance to my husband and son have helped them to achieve their health goals.Thank you once again for your support."
    },
    {
      id: 3,
      text: "7 year old kid with Autism, ADHD and Constipation issues ",
      details: "\"I've had such a wonderful experience with Kreena, the nutrition dietician. She is incredibly knowledgeable and has been so supportive throughout my nutrition journey. I truly appreciate her guidance. I will definitely recommend Kreena and the Nutri Diet Clinic to my friends and family, as I believe they would benefit greatly from her expertise too😊\" "
    },
    {
      id: 4,
      text: "A 32-year-old female client, presented with bloating, acidity, and overweight concerns, enrolled in the Shape Up and Gut Health Program ",
      details: "\"Mujhe Nutri Diet Clinic ka diet plan bahut achha laga meri dietician kreena Nagda Mam thi jinhone mujhe bahut hi achha diet plan diya jisse meri acidity constipation aur bloating me fayda hua mujhe khana kha kar bhi light feel hua.mujhe apke diet plan se knowledge bhi mila😊 meri dietician kreena apne mujhe diet se related achhe se samjhaya aur ap bahut achhe se baat karte ho kreena mam☺️❤️\" "
    },
    {
      id: 5,
      text: "A 28-year-old female client, presented with low energy, fatigue, and overweight concerns, joined the one month weight management program ",
      details: "I had an amazing time in the past month. I'm so happy that I joined this program and I have seen considerable weight loss of 2 kgs in a month. I thought that I ate healthy but was facing a weight plateau. I joined this program without any expectations and it definitely was a great decision.I love that my diet included a lot of tasteful options & was a balanced diet. I didn't have to compromise on any food group. I'm going to follow this through and if I ever feel lost, then I will come back to you"
    },
    {
      id: 6,
      text: "Male with Type 2 Diabetes, hyperglycemia, high creatinine, and lipid dyslipidemia improved sugar control and overall health with tailored nutrition",
      details: "Hi! It was a wonderful time interacting with Kreena. She is soft spoken, helpful and committed. Recipes and nutraceuticals recommended by her were quite effective. My sugars have come down and I’m feeling much better. Thanks a lot and I wish Kreena and the institute all the very best. 👍🏻👍🏻"
    },
    {
      id: 7,
      text: "38-year-old male, a rice lover, lost 5 kg without compromising on his favourite food along with better digestion and higher energy",
      details: "Hi Kareena ji, Thank you so much for your diet plan. It has made me feel more comfortable, energetic, and has improved my digestion. When I shared my health concerns with you, your confidence and reassuring words - 'We'll work on that, it will come down' gave me a lot of hope. I'm following your plan diligently, making sure to include a balance of carbs, fiber, and protein in every meal. I'm very happy with your guidance and support, though I do miss your regular inputs. I'm pleased to share that I've lost 5 kgs and currently weigh 76.7 kg. I will continue my journey with mithahara! -  Ravi Sankar Polisetty"
    }
    // {
    //   id: 6,
    //   text: "A 60-year-old client, presented with weight gain and low energy levels, came with a goal of weight loss and improved vitality through the Shape Up Program ",
    //   details: "I had gained weight and was feeling stuck for a very very long time.I decided to take the weight loss diet program with The Yoga Institute in the month of November 2022.I met Vinita at the institute who guided me on the importance of food and when and how to consume them. She introduced me to the varieties of millet, vegetables, lentils, spices, seeds and nuts. The first week itself made me feel light, energetic and gave me a happy feeling. Her diet plan with easy to make recipes, links to the recipes and recipes given along with the weekly plan had all the varieties along with nutrients. I found myself thoroughly enjoying the process of eating food with the changes brought about in my diet. Vinita's diet plan made me aware of the importance of food through varieties on a daily basis to meet the nutrient requirements for a healthy mind and body.This whole six months journey amazingly changed my outlook with relation to food and my day-to-day habits. I have lost weight but never once did I feel lost, exhausted or negative towards the changes brought about in my diet. I looked forward to each day with enthusiasm in my weight loss journey with Vinita through the institute. Forever grateful! "
    // },

  ];


  const healthPrograms = [
    {
      program: "Shape up program",
      conditions: "Weight loss\nWeight gain, Muscle gain",
      oneMonth: "Rs 3999/-",
      threeMonth: "Rs 8999/-",
      sixMonth: "Rs 13999/-"
    },
    {
      program: "Hormonal imbalance program",
      conditions: "PCOS / PCOD\nInfertility, Thyroid",
      
    },
    {
      program: "Gut Health program",
      conditions: "GERD, Heartburn, Acidity\nDigestion issues / Constipation\nBloating, Gas & Flatulence",
      
    },
    {
      program: "Metabolic disorder program",
      conditions: "Type 2 Diabetes Mellitus\nCholesterol, Hypertension",
      
    },
    {
      program: "Maternal Program",
      conditions: "Pregnancy, Lactation\nPregnancy-induced diabetes",
     
    },
    {
      program: "Client specific diet",
      conditions: "Vegan diet, Ketogenic diet\nLactose intolerant / Gluten free",
     
    },
    {
      program: "Neurological Disorders",
      conditions: "Alzheimer's / Parkinson's",
    
    },
    {
      program: "Clinical Plans",
      conditions: "Diabetes on Insulin / BS\nIBD (Crohn's & Ulcerative Colitis)\nPeptic & Duodenal Ulcers\nBile reflux\nMalabsorption, Pancreatitis\nCancer, COPD, Kidney disorders\nLiver disorders\nEpilepsy",
      oneMonth: "Rs 4999/-",
      threeMonth: "Rs 9999/-",
      sixMonth: "Rs 14999/-"
    },
    {
      program: "Auto-Immune Disorders",
      conditions: "Rheumatoid Arthritis\nAnkylosing Spondylitis\nPsoriasis, Lupus\nSjogren's syndrome\nMultiple Sclerosis (MS)",
     
    }
  ];

  // Mobile pricing data structure
  const mobileCourses = [
    'Shape up program',
    'Hormonal imbalance', 
    'Gut health program',
    'Metabolic disorder',
    'Maternal program',
    'Client specific diet',
    'Neurological Disorders',
    'Clinical Plans',
    'Auto-Immune Disorders',
    'Bride & Groom Holistic Wellness'
  ];

  const mobilePricing = {
    '1 week': { inr: 1999, usd: 29 },
    '1 month': { inr: 3999, usd: 59 },
    '3 months': { inr: 8999, usd: 129 },
    '6 months': { inr: 13999, usd: 199 }
  };

  // Helper function to calculate price based on plan, program, and currency
  const calculatePrice = (planValue, programValue, currencyValue) => {
    if (!planValue || !programValue) return 0;
    
    // Default to INR if currency is not specified or invalid
    const isINR = currencyValue === 'INR' || currencyValue === 'Living in India';
    const isUSD = currencyValue === 'USD' || currencyValue === 'Living in Abroad';
    const useINR = isINR || (!isUSD && !isINR); // Default to INR if neither matches
    
    let priceValue = 0;
    if (programValue === 'Clinical Plans') {
      const clinicalPricing = {
        '1 week': { inr: 0, usd: 0 },
        '1 month': { inr: 4999, usd: 69 },
        '3 months': { inr: 9999, usd: 149 },
        '6 months': { inr: 14999, usd: 219 }
      };
      priceValue = useINR ? clinicalPricing[planValue]?.inr : clinicalPricing[planValue]?.usd;
    } else if (programValue === 'Auto-Immune Disorders') {
      const autoImmunePricing = {
        '1 week': { inr: 0, usd: 0 },
        '1 month': { inr: 4999, usd: 69 },
        '3 months': { inr: 9999, usd: 149 },
        '6 months': { inr: 14999, usd: 219 }
      };
      priceValue = useINR ? autoImmunePricing[planValue]?.inr : autoImmunePricing[planValue]?.usd;
    } else if (programValue === 'Bride & Groom Holistic Wellness') {
      const brideGroomPricing = {
        '1 month': { inr: 5999, usd: 85 },
        '3 months': { inr: 14999, usd: 199 }
      };
      priceValue = useINR ? brideGroomPricing[planValue]?.inr : brideGroomPricing[planValue]?.usd;
    } else {
      priceValue = useINR ? mobilePricing[planValue]?.inr : mobilePricing[planValue]?.usd;
    }
    return priceValue || 0;
  };

  const options = ['1 week','1 month', '3 months', '6 months']
  const options1 = ['Shape up program', 'Hormonal imbalance program', 'Gut health program', 'Metabolic disorder program', 'Maternal program', 'Kids Nutrition', 'Client specific diet', 'Neurological Disorders', 'Clinical Plans', 'Auto-Immune Disorders', 'Bride & Groom Holistic Wellness']
  const options2 = ['Shape up program', 'Hormonal imbalance program', 'Gut health program', 'Metabolic disorder program', 'Maternal program', 'Kids Nutrition', 'Client specific diet', 'Neurological Disorders'];

  // Mobile accordion table data structure
  const mobileTableData = [
    {
      program: "Shape up program",
      healthConditions: ["Weight loss", "Weight gain/ Muscle gain"],
      pricing: {
        "1 week": "Rs 1999/- USD 29",
        "1 month": "Rs 3999/- USD 59", 
        "3 months": "Rs 8999/- USD 129",
        "6 months": "Rs 13999/- USD 199"
      }
    },
    {
      program: "Hormonal imbalance program",
      healthConditions: ["PCOS / PCOD", "Infertility, Thyroid"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "", 
        "6 months": ""
      }
    },
    {
      program: "Gut Health program",
      healthConditions: ["GERD, Heartburn, Acidity", "Digestion issues, Constipation", "Bloating, Gas & Flatulence"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    },
    {
      program: "Metabolic disorder program", 
      healthConditions: ["Type 2 Diabetes Mellitus", "Cholesterol, Hypertension"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    },
    {
      program: "Maternal Program",
      healthConditions: ["Pregnancy, Lactation", "Pregnancy induced diabetes"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    },
    {
      program: "Kids Nutrition",
      healthConditions: ["Weight gain/loss, Autism", "Growth & Development", "ADHD"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    },
    {
      program: "Client specific diet",
      healthConditions: ["Vegan diet, Ketogenic diet", "Lactose intolerant, Gluten free"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    },
    {
      program: "Neurological Disorders",
      healthConditions: ["Alzheimer's, Parkinson"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    },
    {
      program: "Clinical Plans",
      healthConditions: ["Diabetes on insulin IBS, IBD (Crohn's & Ulcerative Colitis)", "Peptic & Duodenal Ulcers, Piles", "Gallbladder stones, Pancreatitis", "Cancer, COPD", "Kidney disorders, Liver disorders", "Epilepsy"],
      pricing: {
        "1 week": "-",
        "1 month": "Rs 4999/- USD 69",
        "3 months": "Rs 9999/- USD 149",
        "6 months": "Rs 14999/- USD 219"
      }
    },
    {
      program: "Auto-Immune Disorders",
      healthConditions: ["Rheumatoid Arthritis, Ankylosing Spondylitis", "Psoriasis, Lupus", "Sjogren's syndrome, Multiple Sclerosis (MS)"],
      pricing: {
        "1 week": "",
        "1 month": "",
        "3 months": "",
        "6 months": ""
      }
    }
  ];

  const mobileTableData2 = [
    {
      program: "Bride & Groom Holistic Wellness",
      healthConditions: [" 1:1 diet consultation + daily support", "Face Yoga and relaxation techniques", "Gut cleanse and glow up tips", "Designed to support all your health concerns"],
      pricing: {
        // "1 week": "Rs 1999/- USD 29",
        "1 month": "Rs 5999/- USD 85", 
        "3 months": "Rs 14999/- USD 199",
        // "6 months": "Rs 13999/- USD 199"
      }
    },
    
  ];

  const [programOptions, setProgramOptions] = useState(options1);

  useEffect(() => {
    if (plan === '1 week') {
      setProgramOptions(options2);
    } else if (plan === '6 months') {
      // Exclude "Bride & Groom Holistic Wellness" for 6 months
      setProgramOptions(options1.filter(option => option !== 'Bride & Groom Holistic Wellness'));
    } else {
      setProgramOptions(options1);
    }
    // Reset selected program when plan changes
    setProgram('');
    // Reset price when plan changes
    setPrice(undefined);
  }, [plan]);

  // Reset price when form closes
  useEffect(() => {
    if (!openForm1 && !openForm2) {
      setPrice(undefined);
    }
  }, [openForm1, openForm2]);

  // Recalculate price when currency, plan, or program changes (if form is open)
  useEffect(() => {
    if ((openForm1 || openForm2) && plan && program) {
      const currencyType = selectedCurrency === 'Living in India' ? 'INR' : 'USD';
      const newPrice = calculatePrice(plan, program, currencyType);
      if (newPrice > 0) {
        setPrice(newPrice);
      }
    }
  }, [selectedCurrency, plan, program, openForm1, openForm2]);

  const selectStyles1 = {
    cursor: 'pointer',
    borderColor: 'rgba(50, 104, 86, 1)',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: '16px',
    fontWeight: '500',
    fontFamily: 'Urbanist',
    borderWidth: '0.25rem',
    borderRadius: '6px',
    borderStyle: 'solid',
    maxWidth: 'fit-content',
    marginRight: '10px',
    height: '100%'
  }

  useEffect(() => {
    if (openForm1) {
      document.body.style.overflow = 'hidden'
    } else {

      document.body.style.overflow = 'auto'
    }
  }, [openForm1])

  useEffect(() => {
    if (openForm2) {
      document.body.style.overflow = 'hidden'
    } else {

      document.body.style.overflow = 'auto'
    }
  }, [openForm2])

  const enrollForm2 = () => {
    if (plan === '' || program === '') {
      setErr(true)
    } else {
      // Calculate price dynamically using helper function
      const priceValue = calculatePrice(plan, program, selectedCurrency === 'Living in India' ? 'INR' : 'USD');
      
      switch (plan) {
        case '1 month':
        case '3 months':
        case '6 months':
          setPrice(priceValue); 
          setErr(false); 
          setOpenForm1(true)
          break
        default:
          break
      }
    }
  }

  const belowenrollForm2 = () => {
    if (plan === '' || program === '') {
      setErr(true)
    } else {
      // Calculate price dynamically using helper function
      const priceValue = calculatePrice(plan, program, selectedCurrency === 'Living in India' ? 'INR' : 'USD');
      
      switch (plan) {
        case '1 month':
        case '3 months':
        case '6 months':
          setPrice(priceValue); 
          setErr(false);
          setOpenForm2(true)
          break
        default:
          break
      }
    }
  }

  const updateGA4 = (amnt, program) => {
    ReactGA.event('add_to_cart', {
      currency: 'INR',
      value: amnt,
      items: [{
        item_name: 'Nutri Diet Clinic',
        item_id: program,
        price: amnt,
        quantity: 1
      }]
    });
    if (window?.clevertap) {
      window.clevertap.event.push("Course_Enroll_Click", {
        "Course_name": 'Nutri Diet Clinic',
        "Page_name": 'nutri-diet',
        "Page_Url": window.location.href,
        "Tenure": plan,
        "date_time_timestamp": new Date().toISOString()
      });


    } else {
      console.error("CleverTap is not initialized.");
    }


  }

  const enrollFrom = () => {
    if (plan === '' || program === '') {
      setErr(true)
    } else {
      // Calculate price dynamically using helper function
      const priceValue = calculatePrice(plan, program, selectedCurrency === 'Living in India' ? 'INR' : 'USD');
      
      switch (plan) {
        case '1 week':
        case '1 month':
        case '3 months':
        case '6 months':
          setPrice(priceValue); 
          setErr(false); 
          setOpenForm1(true)
          updateGA4(priceValue, program)
          break
        default:
          break
      }
      if (program === 'Clinical Plans' || program === 'Auto-Immune Disorders') {
        enrollForm2()
      }
    }
  }



  const belowEnrollFrom = () => {
    if (plan === '' || program === '') {
      setErr(true)
    } else {
      // Calculate price dynamically using helper function
      const priceValue = calculatePrice(plan, program, selectedCurrency === 'Living in India' ? 'INR' : 'USD');
      
      switch (plan) {
        case '1 week':
        case '1 month':
        case '3 months':
        case '6 months':
          setPrice(priceValue); 
          setErr(false); 
          setOpenForm2(true)
          updateGA4(priceValue, program)
          break
        default:
          break
      }
      if (program === 'Clinical Plans' || program === 'Auto-Immune Disorders') {
        belowenrollForm2()
      }
    }
  }


  const scrollToPricing = () => {
    // Find the available batches section by ID
    const availableBatchesSection = document.getElementById('available-batches');

    // If the section exists, scroll to it
    if (availableBatchesSection) {
      availableBatchesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };


  const [isFloating, setIsFloating] = useState(false);
  const benefitsRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (benefitsRef.current) {
        const rect = benefitsRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.3) {
          setIsFloating(true);
        } else {
          setIsFloating(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };


    //CONTACT US
  const phoneNumber = '+91-9967429596';
  const email = 'nutridiet@theyogainstitute.in';

  const handleCopy = (text, label) => {

    // Dismiss any existing toasts first
  toast.dismiss();
  
    navigator.clipboard.writeText(text)
      .then(() => {
        // toast.success(`${label} copied!`);
        toast.success('Copied Successfully!', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
          theme: 'light',
        })
      
      })
      .catch(err => {
        console.error(`Failed to copy ${label}: `, err);
        toast.error(`Failed to copy ${label}`);
      });
  };

  const handleClose = () => {
    setShowModal(false);
  setSelectedReview(null);
  }

  // Add currency options for dropdown
  const currencyOptions = ['Living in India', 'Living in Abroad'];

  return (
    <div className="diet_whole_wrapper">
      <div className="nutri-diet-wrapper">
        <InnerNavComponent abc={Locate} />


        <div className="nutri-diet-container">
          <div className="hero-section">
            <div className="hero-content">
              <h1 className="hero-title">
                Transform Your Health
                <br />
                with Personalized Nutrition❤️
              </h1>
              <div className="highlight-underline_top"></div>
              <p className="hero-subtitle">
                {`Balance your diet effortlessly with TYI's Nutri Diet Clinic`}
                <div className='no_mobile'><br /></div>
                where yogic wisdom meets modern nutrition for a healthier you.
              </p>

              <div className="customers-section">
                <div className="avatars">
                  <img src={follower} alt="Community" />
                </div>
                <span className="customer-count">1000+ Happy Customers</span>

              </div>

              <button className="pricing-btn" onClick={scrollToPricing}>
                See our pricing plan
                <div style={{ display: 'flex' }}>
                  <img src={nutri_diet_hero_wrapper} alt="" />
                </div>
              </button>
            </div>

            <div className="hero-image-container">
              <div className="food-plate">
                <img src={nutridiet_img} alt="Healthy Food Plate" className='nutridiet_img' />
              </div>
            </div>
          </div>


          <div ref={benefitsRef} className="nutri-diet-benefit">


            <h2 style={{ textAlign: 'center' }}>
              <span className="title">Why Choose the</span> <span className="highlight">Nutri - Diet Clinic</span>
            </h2>

            <div className="benefits-grid">
              <div className="benefit-card">
                <div className="icon-container">
                  <div className="benefitcard">
                    <img src={benefitcard} alt="" />
                  </div>
                </div>
                <h3 className='benefit-card_spacing'>Holistic Approach:</h3>

                <span className='benefitp'>
                TYIs 105-year legacy of holistic health meets contemporary nutrition practices, focusing on the well-being of your body, mind, and spirit.

                </span>
              </div>

              <div className="benefit-card">
                <div className="icon-container">
                  <div className="benefitcard">
                    <img src={benefitcard} alt="" />
                  </div>
                </div>
                <h3 className='benefit-card_spacing'>Personalized Plans:</h3>
                <span className='benefitp'>
                Our experts craft customized nutrition strategies tailored to your unique health goals and lifestyle.
                </span>
              </div>

              <div className="benefit-card">
                <div className="icon-container">
                  <div className="benefitcard">
                    <img src={benefitcard} alt="" />
                  </div>
                </div>
                <h3 className='benefit-card_spacing'>Sustainable Habits:</h3>
                <span className='benefitp'>
                We go beyond temporary diets, emphasizing lasting, practical eating habits that can easily become part of your daily life.
                </span>
              </div>

              <div className="benefit-card">
                <div className="icon-container">
                  <div className="benefitcard">
                    <img src={benefitcard} alt="" />
                  </div>
                </div>
                <h3 className='benefit-card_spacing'>Affordable for All:</h3>
                <span className='benefitp'>
                  {` Good health shouldn't be a luxury. Our budget-friendly plans ensure wellness is accessible to everyone. `}
                </span>
              </div>

              <div className="benefit-card centered-card">
                <div className="icon-container">
                  <div className="benefitcard">
                    <img src={benefitcard} alt="" />
                  </div>
                </div>
                <h3 className='benefit-card_spacing'>Balanced and Practical Solutions:</h3>
                <span className='benefitp'>
                Seamlessly blending traditional recipes with simple, homemade solutions, our approach fits even the busiest schedules, making healthy choices both realistic and achievable.
                </span>
              </div>
            </div>
          </div>


          <div style={{ position: 'relative' }}>
            <div className="highlights-container">
              <h2 style={{ textAlign: 'center' }}>
                <span className="title_2">Highlight of  </span> <span className="highlight_2">Nutri - Diet Clinic </span>
              </h2>
              <div className="highlights-grid">
                {highlightsData.map((item, index) => (
                  <div key={index} className="highlight-card">
                    <div className="highlight-image-container">
                      <img src={item.img} alt="Healthy salad plate" className="saladPlateImage" />
                    </div>
                    <div className="highlight-content">
                      <div className="highlight-category">
                        {item.category} {item.subcategory}
                      </div>
                      <h3 className="highlight-title">{item.title}</h3>
                      <p className="highlight-description">({item.description})</p>
                      <div className="highlight-underline"></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="highlights-wave">
              <img src={greenbackground} alt="Wave background" />
            </div>
          </div>


          <section className="transform_wrapper">

            <div className="left_fruit_container">
              <img src={right_fruit_1} alt="" className='fruit_1' />
              <img src={left_fruit_2} alt="" className='fruit_2' />
              <img src={left_image_3} alt="" className='fruit_3' />
              <img src={left_image_3} alt="" className='fruit_4' />
            </div>

            <main className="center_transform">

              <h2 style={{ textAlign: 'center' }}>
                <span className="title">Your Structured Health</span> <span className="highlight">Transformation journey</span>
              </h2>

              <div className="journey_main_wrapper">
                <div className="timeline-img-container">
                  <img src={frame_timeline_new} alt="Journey Timeline" className="timeline-svg" />
                  <img src={timeline} alt="Journey Timeline" className='timeline-mobile' />
                </div>

                <div className="journey_first_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Enrollment</h3>
                    <p>Enrollment and Appointment Scheduling</p>
                  </div>
                </div>

                <div className="journey_second_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Consultation Call</h3>
                    <p>Detailed 1 hour long comprehensive consultation call to understand your Physical, Mental and Emotional aspect for holistic health</p>
                    <span className='card_p'><strong>(Mode: Offline | Online)</strong></span>
                  </div>
                </div>

                <div className="journey_third_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Body Analysis</h3>
                    <span className='card_p'><p><strong>For offline consultations:</strong></p></span>
                    <div style={{marginLeft: '15px', fontSize: '16px', fontWeight:'500', marginBottom: '20px'}}>
                    <p><li>Body composition analysis to understand the Weight, Muscle mass %, Fat mass %, Visceral fat, Body age and more</li></p>
                    </div>
                    <span className='card_p'><p><strong>For online clients:</strong></p></span>
                    <div style={{marginLeft: '15px', fontSize: '16px', fontWeight:'500'}}>
                    <p><li>Body measurements- height, weight, waist, and hip circumference, BMI</li></p>
                    </div>
                  </div>
                </div>

                <div className="journey_fourth_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Biomedical Insights</h3>
                    <p>Review medical reports, including CBC, Lipid Profile, Kidney Function, Thyroid Profile, Liver Function Tests, Vitamin D, and Vitamin B12 levels.
                    </p>
                    <p>If necessary, recommend additional tests for a clearer health picture (reports should ideally be recent, within three to six months).</p>
                    <p>(Disclaimer: Pathological tests are not included in our services and must be conducted independently by clients.)
                    </p>
                  </div>
                </div>

                <div className="journey_fifth_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Detailed Client History</h3>
                    <p>Health Background, Medical history (e.g., past illnesses, surgeries, or chronic conditions), Present issues, Family history & Nutrient Deficiencies 
                    </p>
                  </div>
                </div>

                <div className="journey_sixth_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Holistic Health Assessment</h3>
                    <p>Lifestyle Factors: Sleep patterns, Stress levels, Mindset, Emotions, Hydration, Eating habits and food preferences.
                    </p>
                  </div>
                </div>

                <div className="journey_seventh_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Dietary Habits Analysis</h3>
                    <p>Detailed recall of dietary intake and assessing meal timing, portion sizes, and frequency of nutrient-dense versus processed foods to identify gaps and areas for improvement.</p>
                  </div>
                </div>

                <div className="journey_eigth_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Personalized Dietary Recommendations & Tailored Meal Plan</h3>
                    <div style={{marginLeft: '15px', fontSize: '16px', fontWeight:'500', color: '#333333'}}>
                    <p><li>Customized diet plan based on your nutritional needs, health goals, and food preferences.</li></p> <br/>
                    <p><li>Focusing on balanced meals, using sustainable and locally available food options in such a way that it fits seamlessly into your cultural, professional, and personal lifestyle requirements.</li></p>
                  </div>
                  </div>
                </div>

                <div className="journey_nine_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Restaurant and Travel Guide</h3>
                    <p> We will provide a curated guide to healthy dining options across all cuisines, along with practical travel tips and flight-friendly recommendations to help you stay on track wherever you go.</p>
                  </div>
                </div>

                <div className="journey_ten_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Exercise Recommendations</h3>
                    <p> Resources of exercises suited to  your fitness level and health objectives will be shared.  </p>
                  </div>
                </div>

                <div className="journey_eleven_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Daily WhatsApp Support & Real-Time Guidance</h3>
                    <p> Daily support for addressing queries, providing feedback and ongoing motivation ensuring you stay on track to achieve your goals. </p>
                  </div>
                </div>

                <div className="journey_twelve_content_wrapper">
                  <div className="journey_card-content">
                    <h3>Follow-ups & Progress Monitoring</h3>
                    <p> Every 15 days and at the end of your plan, we conduct a thorough review of your body composition, measurements, and weight, alongside tracking improvements in your symptoms, energy levels, and overall well-being. 


                    </p>
                    <p>These insights empower us to fine-tune your diet and exercise plan, ensuring you overcome challenges, stay motivated, and achieve lasting results!</p>
                  </div>
                </div>
              </div>
            </main>

            <div className="right_fruit_container">
              <img src={right_top_1} alt="" className='right_fruit_1' />
              <img src={right_2} alt="" className='right_fruit_2' />
              <img src={right_fruit_new_3} alt="" className='right_fruit_3' />
              <img src={right_fruit_new_3} alt="" className='right_fruit_4' />
              <img src={right_5} alt="" className='right_fruit_5' />
            </div>
          </section>

          <section className="journey_wrapper">
            <main className="center_journey">

              <h2 style={{ textAlign: 'center' }}>
                <span className="title">Your Structured Health</span><br /> <span className="highlight">Transformation journey</span>
              </h2>

              <div className="health-journey-container1">
                {/* <img src={TYI_Mobile_v2} alt="Journey TImeline" /> */}

               <div class="timeline">
  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">1</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Enrollment</h3>
        <p>Enrollment and Appointment Scheduling</p>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">2</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Consultation Call</h3>
      <p>Detailed 1 hour long comprehensive consultation call to understand your Physical, Mental and Emotional aspect for holistic health</p>
                    <span className='card_p'><strong>(Mode: Offline | Online)</strong></span>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">3</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Body Analysis</h3>
        <span className='card_p'><p><strong>For offline consultations:</strong></p></span>
                    <div style={{marginLeft: '0px', fontSize: '16px', fontWeight:'500', marginBottom: '10px'}}>
                    <p><li>Body composition analysis to understand the Weight, Muscle mass %, Fat mass %, Visceral fat, Body age and more</li></p>
                    </div>
                    <span className='card_p'><p><strong>For online clients:</strong></p></span>
                    <div style={{marginLeft: '0px', fontSize: '16px', fontWeight:'500'}}>
                    <p><li>Body measurements- height, weight, waist, and hip circumference, BMI</li></p>
      </div>
    </div>
  </div>
</div>

<div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">4</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
         <h3>Biomedical Insights</h3>
                    <p>Review medical reports, including CBC, Lipid Profile, Kidney Function, Thyroid Profile, Liver Function Tests, Vitamin D, and Vitamin B12 levels.
                    </p>
                    <p>If necessary, recommend additional tests for a clearer health picture (reports should ideally be recent, within three to six months).</p>
                    <p>(Disclaimer: Pathological tests are not included in our services and must be conducted independently by clients.)
                    </p>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">5</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
         <h3>Detailed Client History</h3>
                    <p>Health Background, Medical history (e.g., past illnesses, surgeries, or chronic conditions), Present issues, Family history & Nutrient Deficiencies 
                    </p>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">6</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Holistic Health Assessment</h3>
                    <p>Lifestyle Factors: Sleep patterns, Stress levels, Mindset, Emotions, Hydration, Eating habits and food preferences.
                    </p>
    </div>
  </div>
</div>

<div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">7</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Dietary Habits Analysis</h3>
                    <p>Detailed recall of dietary intake and assessing meal timing, portion sizes, and frequency of nutrient-dense versus processed foods to identify gaps and areas for improvement.</p>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">8</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
       <h3>Personalized Dietary Recommendations & Tailored Meal Plan</h3>
                    <div style={{marginLeft: '0px', fontSize: '16px', fontWeight:'500', color: '#333333'}}>
                    <p><li>Customized diet plan based on your nutritional needs, health goals, and food preferences.</li></p> <br/>
                    <p><li>Focusing on balanced meals, using sustainable and locally available food options in such a way that it fits seamlessly into your cultural, professional, and personal lifestyle requirements.</li></p>
                  </div>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">9</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Restaurant and Travel Guide</h3>
                    <p> We will provide a curated guide to healthy dining options across all cuisines, along with practical travel tips and flight-friendly recommendations to help you stay on track wherever you go.</p>
    </div>
  </div>
</div>

<div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">10</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Exercise Recommendations</h3>
                    <p> Resources of exercises suited to  your fitness level and health objectives will be shared.  </p>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">11</div>
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Daily WhatsApp Support & Real-Time Guidance</h3>
                    <p> Daily support for addressing queries, providing feedback and ongoing motivation ensuring you stay on track to achieve your goals. </p>
      </div>
    </div>
  </div>

  <div class="timeline-step">
    <div class="timeline-left">
      <div class="timeline-circle">12</div>
      <img src={mobile_arrow_down_line} alt="" />
    </div>
    <div class="timeline-right">
      <div class="timeline-content">
        <h3>Follow-ups & Progress Monitoring</h3>
                    <p> Every 15 days and at the end of your plan, we conduct a thorough review of your body composition, measurements, and weight, alongside tracking improvements in your symptoms, energy levels, and overall well-being. 


                    </p>
                    <p>These insights empower us to fine-tune your diet and exercise plan, ensuring you overcome challenges, stay motivated, and achieve lasting results!</p>
    </div>
  </div>
</div>
              </div>
              </div>
            </main>
          </section>

          <div className="health-plan-container" id='available-batches'>
  <div className="health-plan-header">
    <h2 className="health-plan-title"><span className='meet-our'>check our</span><span className='plantitle'>Health plan Investments </span></h2>
  </div>
  <p className='heading_plain-container'>Have Multiple Health Concerns?</p>
  <p className='heading_plain-below_container'>Select the program that matches your primary issue. Other conditions will still be addressed during your consultation for a complete, personalized plan.</p>

{/* <div className="health-plan-table-showing_plans_onSelect_mobile">
  <div className="mobile-pricing-header">
    <div className="mobile-pricing-label">Quick summary for 
    your Health Plan</div>
    <div className="mobile-dropdowns-container">
      <select 
        value={selectedDuration} 
        onChange={(e) => setSelectedDuration(e.target.value)}
        className="mobile-duration-select"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>
  
  <div className="mobile-courses-list">
    {mobileCourses
      .filter(course => {
        // For 1 week, exclude Clinical Plans and Auto-Immune Disorders
        if (selectedDuration === '1 week') {
          return course !== 'Clinical Plans' && course !== 'Auto-Immune Disorders';
        }
        // For all other durations, show all courses
        return true;
      })
      .map((course, index) => (
        <div key={index} className="mobile-course-item">
          <div className="mobile-course-number">{index + 1}</div>
          <div className="mobile-course-name">{course}</div>
          <div className="mobile-course-pricing">
            <span className="mobile-price-inr">₹ {mobilePricing[selectedDuration].inr.toLocaleString()}</span>
            <span className="mobile-price-usd">/ USD {mobilePricing[selectedDuration].usd}</span>
          </div>
        </div>
      ))}
  </div>

  <div className="mobile_view_all_pricing_highlighter">
        <p>View full pricing & details below</p>
  </div>
</div> */}

<div className="health-plan-table-showing_plans_onSelect_mobile">
  <div className="mobile-pricing-header">
    <div className="mobile-pricing-label">Quick summary for your Health Plan</div>
    <div className="mobile-dropdowns-container">
      <select 
        value={selectedDuration} 
        onChange={(e) => setSelectedDuration(e.target.value)}
        className="mobile-duration-select"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>
  
  <div className="mobile-courses-list">
    {mobileCourses
      .filter(course => {
        // For 1 week, exclude Clinical Plans, Auto-Immune Disorders, and Bride & Groom Holistic Wellness
        if (selectedDuration === '1 week') {
          return course !== 'Clinical Plans' && course !== 'Auto-Immune Disorders' && course !== 'Bride & Groom Holistic Wellness';
        }
        // For 6 months, exclude Bride & Groom Holistic Wellness
        if (selectedDuration === '6 months') {
          return course !== 'Bride & Groom Holistic Wellness';
        }
        return true;
      })
      .map((course, index) => {
        // Special pricing for Clinical Plans and Auto-Immune Disorders
        const isSpecialCourse = course === 'Clinical Plans' || course === 'Auto-Immune Disorders';
        // Special pricing for Bride & Groom Holistic Wellness
        const isBrideGroom = course === 'Bride & Groom Holistic Wellness';
        let priceInr = mobilePricing[selectedDuration].inr;
        let priceUsd = mobilePricing[selectedDuration].usd;
        
        if (isSpecialCourse) {
          switch(selectedDuration) {
            case '1 month':
              priceInr = 4999;
              priceUsd = 69;
              break;
            case '3 months':
              priceInr = 9999;
              priceUsd = 149;
              break;
            case '6 months':
              priceInr = 14999;
              priceUsd = 219;
              break;
            default:
              // Keep default pricing for other durations
              break;
          }
        } else if (isBrideGroom) {
          switch(selectedDuration) {
            case '1 month':
              priceInr = 5999;
              priceUsd = 85;
              break;
            case '3 months':
              priceInr = 14999;
              priceUsd = 199;
              break;
            default:
              // Keep default pricing for other durations (shouldn't show for 1 week or 6 months)
              break;
          }
        }

        return (
          <div key={index} className="mobile-course-item">
            <div className="mobile-course-number">{index + 1}</div>
            <div className="mobile-course-name">{course}</div>
            <div className="mobile-course-pricing">
              <span className="mobile-price-inr">₹ {priceInr.toLocaleString()}</span>
              <span className="mobile-price-usd">/ USD {priceUsd}</span>
            </div>
          </div>
        );
      })}
  </div>

  <div className="mobile_view_all_pricing_highlighter">
    <p>View full pricing & details below</p>
  </div>
</div>


<div className='mobile_health_table_Programs'>
  <div className="mobile-table-container">
    <table className="mobile-table">
      <thead>
        <tr>
          <th className="mobile-table-header-cell">Programs</th>
          <th className="mobile-table-header-cell">1 Week</th>
          <th className="mobile-table-header-cell">1 Month</th>
          <th className="mobile-table-header-cell">3 Months</th>
          <th className="mobile-table-header-cell">6 Months</th>
        </tr>
      </thead>
      <tbody>
        {mobileTableData.map((item, index) => (
          <tr key={index} className={`mobile-table-row ${item.program === "Neurological Disorders" ? 'separator-after' : ''}`}>
            <td className="mobile-table-program-cell">
              <div className="program-header" onClick={() => toggleAccordion(item.program)}>
                <span className={`accordion-arrow ${expandedPrograms[item.program] ? 'expanded' : ''}`}>
                  <img src={ne_mobile_table} alt="" />
                </span>
                <span className="program-name">{item.program}</span>
              </div>
              {expandedPrograms[item.program] && (
                <div className="health-conditions-list">
                  <div className="conditions-label">Health Conditions:</div>
                  {item.healthConditions.map((condition, condIndex) => (
                    <div key={condIndex} className="condition-item">
                      {condition}
                    </div>
                  ))}
                </div>
              )}
            </td>
            <td className="mobile-table-price-cell">
              {item.program === "Shape up program" ? item.pricing["1 week"] : 
               item.program === "Clinical Plans" ? item.pricing["1 week"] : ""}
            </td>
            <td className="mobile-table-price-cell">
              {item.program === "Shape up program" ? item.pricing["1 month"] : 
               item.program === "Clinical Plans" ? item.pricing["1 month"] : ""}
            </td>
            <td className="mobile-table-price-cell">
              {item.program === "Shape up program" ? item.pricing["3 months"] : 
               item.program === "Clinical Plans" ? item.pricing["3 months"] : ""}
            </td>
            <td className="mobile-table-price-cell">
              {item.program === "Shape up program" ? item.pricing["6 months"] : 
               item.program === "Clinical Plans" ? item.pricing["6 months"] : ""}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

<div className='mobile_health_table_Programs'>
  <div className="mobile-table-container">
    <table className="mobile-table">
      <thead>
        <tr>
          <th className="mobile-table-header-cell">Special Program</th>
          <th className="mobile-table-header-cell">1 Month</th>
          <th className="mobile-table-header-cell">3 Months</th>
        </tr>
      </thead>
      <tbody>
        {mobileTableData2.map((item, index) => (
          <tr key={index} className={`mobile-table-row ${item.program === "Neurological Disorders" ? 'separator-after' : ''}`}>
            <td className="mobile-table-program-cell">
              <div className="program-header" onClick={() => toggleAccordion(item.program)}>
                <span className={`accordion-arrow ${expandedPrograms[item.program] ? 'expanded' : ''}`}>
                  <img src={ne_mobile_table} alt="" />
                </span>
                <span className="program-name">{item.program}</span>
              </div>
              {expandedPrograms[item.program] && (
                <div className="health-conditions-list">
                  <div className="conditions-label">Program Inclusions:</div>
                  {item.healthConditions.map((condition, condIndex) => (
                    <div key={condIndex} className="condition-item">
                      {condition}
                    </div>
                  ))}
                </div>
              )}
            </td>
            <td className="mobile-table-price-cell">
              {item.pricing["1 month"] || ""}
            </td>
            <td className="mobile-table-price-cell">
              {item.pricing["3 months"] || ""}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>


  <div className="health-plan-table-container">
    <table className="health-plan-table">
      <thead>
        <tr>
          <th className="program-column">Programs</th>
          <th className="conditions-column">Health Conditions</th>
          <th className="plan-column">1 Week plan</th>
          <th className="plan-column">1 Month plan</th>
          <th className="plan-column">3 Month plan</th>
          <th className="plan-column">6 Month plan</th>
        </tr>
      </thead>
      <tbody>
        <tr style={{marginBottom: '60px'}}>
          <td>Shape up program</td>
          <td>
            <div className="condition-line">{`Weight loss`}</div>
            <div className="condition-line">{`Weight gain/ Muscle gain
`}</div>
          </td>
          <td colSpan={4} style={{ backgroundColor: '#1E96881A', position: 'relative', left: '0', top: '0'}}><span style={{position:'absolute', top:'50%', left: '50%', transform: 'translate(-50%, -50%)', fontFamily: 'Urbanist', fontSize: '28px', fontWeight: '500'}}>Clients Residing in India</span></td>
        </tr>
        
        <tr style={{marginBottom: '60px'}}>
          <td>Hormonal imbalance program</td>
          <td>
            <div className="condition-line">{`PCOS / PCOD`}</div>
            <div className="condition-line">{`Infertility, Thyroid`}</div>
          </td>
          <td>Rs 1999/-</td>
          <td>Rs 3999/-</td>
          <td>Rs 8999/-</td>
          <td>Rs 13999/-</td>
        </tr>
        
        <tr style={{marginBottom: '60px'}}>
          <td>Gut Health program</td>
          <td>
            <div className="condition-line">{`GERD, Heartburn, Acidity,`}</div>
            <div className="condition-line">{`Digestion issues , Constipation`}</div>
            <div className="condition-line">{`Bloating, Gas & Flatulence`}</div>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        
        <tr style={{marginBottom: '60px'}}>
          <td>Metabolic disorder program</td>
          <td>
            <div className="condition-line">Type 2 Diabetes Mellitus</div>
            <div className="condition-line">{`Cholesterol, Hypertension`}</div>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        
        <tr style={{marginBottom: '60px'}}>
          <td>Maternal Program</td>
          <td>
            <div className="condition-line">{`Pregnancy, Lactation,`}</div>
            <div className="condition-line">{`Pregnancy induced diabetes`}</div>
          </td>
          <td colSpan={4} style={{ backgroundColor: '#1E96881A', position: 'relative', left: '0', top: '0'}}><span style={{position:'absolute', top:'50%', left: '50%', transform: 'translate(-50%, -50%)', fontFamily: 'Urbanist', fontSize: '28px', fontWeight: '500'}}>Clients Residing in Abroad</span></td>
        </tr>

        <tr style={{marginBottom: '60px'}}>
          <td>Kids Nutrition</td>
          <td>
            <div className="condition-line">{`Weight gain/loss, Autism,`}</div>
            <div className="condition-line">{`Growth & Development, ADHD`}</div>
          </td>
          <td>USD 29</td>
          <td>USD 59</td>
          <td>USD 129</td>
          <td>USD 199</td>
        </tr>
        
        <tr style={{marginBottom: '60px'}}>
          <td>Client specific diet</td>
          <td>
            <div className="condition-line">{`Vegan diet, Ketogenic diet,`}</div>
            <div className="condition-line">{`Lactose intolerant,  Gluten free`}</div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        
        <tr style={{marginBottom: '60px'}}>
          <td>Neurological Disorders</td>
          <td>
            <div className="condition-line">{`Alzheimer's, Parkinson`}</div>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        
      <tr style={{ marginBottom: '60px' }}>
  <td style={{ verticalAlign: 'top', width: '20%' }}>Clinical Plans</td>
  <td style={{ verticalAlign: 'top', width: '30%' }}>
    <div className="condition-line">{`Diabetes on insulin IBS,`}</div>
    <div className="condition-line">{`IBD (Crohn's & Ulcerative Colitis),`}</div>
    <div className="condition-line">{`Peptic & Duodenal Ulcers,`}</div>
    <div className="condition-line">Piles, Gall bladderstones,</div>
    <div className="condition-line">{`Pancreatitis, Cancer,`}</div>
    <div className="condition-line">{`COPD, Kidney disorders,`}</div>
    <div className="condition-line">Liver disorders,</div>
    <div className="condition-line">Epilepsy</div>
  </td>
  <td colSpan={4} style={{ padding: 0, width: '50%' }}>
    {/* Header row */}
    <div style={{
      backgroundColor: '#1E96881A',
      padding: '40px 0',
      textAlign: 'center',
      fontFamily: 'Urbanist',
      fontSize: '28px',
      fontWeight: '500',
      boxSizing: 'border-box'
    }}>
      Clients Residing in India
    </div>
    
    {/* Price row - using table for perfect alignment */}
    <table style={{ 
      width: '100%', 
      borderCollapse: 'collapse',
      tableLayout: 'fixed',
      height: '100%',
    }}>
      <tbody>
        <tr>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>-</td>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>Rs 4999/-</td>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>Rs 9999/-</td>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>Rs 14999/-</td>
        </tr>
      </tbody>
    </table>
  </td>
</tr>
        
        {/* <tr style={{marginBottom: '60px'}}>
          <td>Auto-Immune Disorders</td>
          <td>
            <div className="condition-line">Rheumatoid Arthritis,</div>
            <div className="condition-line">Ankylosing Spondylitis,</div>
            <div className="condition-line">{`Psoriasis, Lupus`}</div>
            <div className="condition-line">{`Sjogren's syndrome,`}</div>
            <div className="condition-line">{`Multiple Sclerosis (MS)`}</div>
          </td>
          <td></td>
          <td></td>
          <td></td>
        </tr> */}

        <tr style={{ marginBottom: '60px' }}>
  <td style={{ verticalAlign: 'top', width: '20%' }}>Auto-Immune Disorders</td>
  <td style={{ verticalAlign: 'top', width: '30%' }}>
    <div className="condition-line">Rheumatoid Arthritis,</div>
            <div className="condition-line">Ankylosing Spondylitis,</div>
            <div className="condition-line">{`Psoriasis, Lupus`}</div>
            <div className="condition-line">{`Sjogren's syndrome,`}</div>
            <div className="condition-line">{`Multiple Sclerosis (MS)`}</div>
  </td>
  <td colSpan={4} style={{ padding: 0, width: '50%' }}>
    {/* Header row */}
    <div style={{
      backgroundColor: '#1E96881A',
      padding: '40px 0',
      textAlign: 'center',
      fontFamily: 'Urbanist',
      fontSize: '28px',
      fontWeight: '500',
      boxSizing: 'border-box'
    }}>
      Clients Residing in Abroad
    </div>
    
    {/* Price row - using table for perfect alignment */}
    <table style={{ 
      width: '100%', 
      borderCollapse: 'collapse',
      tableLayout: 'fixed',
      height: '49%',
    }}>
      <tbody>
        <tr>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>-</td>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>USD 69</td>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>USD 149</td>
          <td style={{
            textAlign: 'center',
            padding: '12px 0',
            borderRight: '1px solid #1E9688',
            boxSizing: 'border-box'
          }}>USD 219</td>
        </tr>
      </tbody>
    </table>
  </td>
</tr>
        
      </tbody>
    </table>
  </div>

  <div className="health-plan-table-container">
    <table className="health-plan-table">
      <thead>
        <tr>
          <th className="program-column">Special Program</th>
          <th className="conditions-column">Program Inclusions</th>
          <th className="plan-column">Investment (per person)</th>
          {/* <th className="plan-column">1 Month plan</th>
          <th className="plan-column">3 Month plan</th>
          <th className="plan-column">6 Month plan</th> */}
        </tr>
      </thead>
      <tbody>
        <tr style={{marginBottom: '60px'}}>
          <td>Bride & Groom Holistic Wellness</td>
          <td>
            <div className="condition-line">{`• 1:1 diet consultation + daily support`}</div>
            <div className="condition-line">{`• Face Yoga and relaxation techniques
`}</div>
<div className="condition-line">{`• Gut cleanse and glow up tips`}</div>
            <div className="condition-line">{`• Designed to support all your health concerns
`}</div>
          </td>
          <td>
            <div className="condition-line">{`1 Month : Rs 5999 / $ 85`}</div>
            <div className="condition-line">{`3 Months : Rs 14999 / $ 199
`}</div>
          </td>
          
        </tr>
        
       

     
        
      </tbody>
    </table>
  </div>

 
          </div> 


          <ToastContainer />
          <div className="contact-wrapper">

            <div className="contact-container">
              <div className="page-header">
                <p>By following this structured, holistic process, we offer a comprehensive and client-focused approach to achieving <span className="highlight-contact">optimal health</span> and <span className="highlight-contact"> wellness.</span></p>
              </div>
              <div className="highlight-underline_top_contact"></div>
              <div className="contact-box">
                <button className="contact-button">Contact US</button>
                <div className="contact-details">
                  <div className="contact-item" style={{ justifyContent: 'start'}}>
                    <div className='contact_social_wrapper'>
                      <span className="contact-icon">
                        <img src={phoneicon} alt="" />
                      </span>
                      <span>For Appointments: </span>
                    </div>

                    <div className='contact-name' style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
                      <span>{phoneNumber}</span>
                      <img
                        src={copy}
                        alt="Copy Phone"
                        onClick={() => handleCopy(phoneNumber, 'Phone number')}
                        style={{ cursor: 'pointer', marginLeft: '8px', width: '16px', height: '16px' }}
                        title="Copy phone number"
                      />
                    </div>
                  
                  </div>

                  <div className="contact-item">
                    <div className='contact_social_wrapper'>
                      <span className="contact-icon">
                        <img src={phoneicon} alt="" />
                      </span>
                      <span>Email ID : </span>
                    </div>

                    <div className='contact-name' style={{ display: 'flex', alignItems: 'center' }}>
                      <a
                        href={`mailto:${email}`}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                        title="Send an email"
                      >
                        {email}
                      </a>
                      <img
                        src={copy}
                        alt="Copy Email"
                        onClick={() => handleCopy(email, 'Email')}
                        style={{ cursor: 'pointer', marginLeft: '8px', width: '16px', height: '16px' }}
                        title="Copy email"
                      />
                    </div>
                    {/* <ToastContainer /> */}
                  </div>

                  <div className="contact-item wd" style={{ justifyContent: 'start'}}>
                    <div className='contact_social_wrapper'>
                      <span className="contact-icon">
                        <img src={phoneicon} alt="" />
                      </span>
                      <span>Working Days : </span>
                    </div>
                    <div className='contact-name' style={{ display: 'flex' }}>
                      <span>Monday to Saturday <br /> (Sunday is closed) </span>
                    </div>
                  </div>

                  <div className="contact-item wt" style={{ justifyContent: 'start'}}>
                    <div className='contact_social_wrapper'>
                      <span className="contact-icon">
                        <img src={phoneicon} alt="" />
                      </span>
                      <span>Working Timings : </span>
                    </div>
                    <div className='contact-name' style={{ display: 'flex' }}>
                      <span>10 am to 6 pm IST </span>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="terms-container" type="a">
              <h3>→ Terms and conditions:</h3>
              <ol type="a">
                <li>
                We kindly request our overseas clients to schedule consultation calls in alignment with Indian business hours for seamless communication and support. Thank you for your understanding and cooperation.
                </li>
                <li>
                Please note that all fees are non-refundable and non-transferable under any circumstances.
                </li>
                <li>
                The results may vary according to the age, genetics, medical conditions, physical activity and gender and diet compliance.
                </li>
                <li>
                For the seamless execution of the program, we kindly request timely adherence, as we may not be able to accommodate any gaps/ inconsistencies due to non-compliance.
                </li>
              </ol>
            </div>

            <div className='health_wrapper_bottom'>

<div>
  <p className='desc_health_first'>🎯 Start Your Personalized Health Journey!</p>
  <p className='des_health_second'>Select your program & package to begin your transformation.</p>
</div>

<div
  id="date-select-mobile"
  style={{ display: 'flex', alignItems: 'center' }}
>
  <select
    value={selectedCurrency}
    onChange={e => setSelectedCurrency(e.target.value)}
    style={{ 
      ...selectStyles1, 
      minWidth: '90px', 
      marginRight: '10px', 
      color: '#fff', 
      background: 'rgba(255, 255, 254, 0.3)', 
      padding: '14px',
      '& option': {
        backgroundColor: '#000',
        color: '#fff'
      }
    }}
    className="currency-dropdown"
  >
    {currencyOptions.map(option => (
      <option key={option} value={option} style={{ backgroundColor: '#000', color: '#fff' }}>{option}</option>
    ))}
  </select>
  <SelectDropDown
    currentValue={plan}
    changeCurrentValue={setPlan}
    text={'Select Package'}
    isStyles={selectStyles1}
    dates={options}
  />{' '}
  <SelectDropDown
    currentValue={program}
    changeCurrentValue={setProgram}
    text={'Select Program'}
    isStyles={selectStyles1}
    dates={programOptions}
  />
  <CommonBtn text='Enroll Now' buttonAction={enrollFrom} />
  <div style={{ color: '#FF3B30', fontSize: '14px', fontWeight:'600', margin:'10px'}}>
  {err && <small> Please select package/program* </small>}
  </div>
  {openForm1 && <SubcriptionForm packageName={plan} packagePrice={calculatePrice(plan, program, selectedCurrency === 'Living in India' ? 'INR' : 'USD')} selectedPackageName={program} currency={selectedCurrency} closeForm={setOpenForm1} />}
</div>
</div>
         
          </div>





{/* <div className="health-plan-container" id='available-batches'>
  <div className="health-plan-header">
    <h2 className="health-plan-title"><span className='meet-our'>check our</span><span className='plantitle'>Health plan Investments </span></h2>
  </div>
  <div className="health-plan-table-container">
    <table className="health-plan-table">
      <thead>
        <tr>
          <th className="program-column">Programs</th>
          <th className="conditions-column">Health Conditions</th>
          <th className="plan-column">1 Month plan</th>
          <th className="plan-column">3 Month plan</th>
          <th className="plan-column">6 Month plan</th>
        </tr>
      </thead>
      <tbody>
        {healthPrograms.map((program, index) => (
          <tr key={index}>
            <td>{program.program}</td>
            <td>
              {program.conditions.split('\n').map((condition, condIndex) => (
                <div key={condIndex} className="condition-line">{condition}</div>
              ))}
            </td>
            <td>{program.oneMonth}</td>
            <td>{program.threeMonth}</td>
            <td>{program.sixMonth}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div> */}



           




        
         

          <div className='diet-container'>
            <div className="nutritionist-container">
              <div className="header">
                <h1 className="main-title">
                  <span className="meet-our">meet our</span><span className='diettitle'>Nutritionist and Dietician</span>
                </h1>
              </div>

              <div className="cards-container">
                <div className="profile-card">
                  <div className='nurtition'>
                    <img src={Vinita} alt='' />
                  </div>
                  <div className="profile-details">
                    <h2 className="profile-name">Vinita Ashok Sakpal (Sr. Nutritionist) </h2>
                    <div className="profile-list">
                      <h3 className="profile-title">Qualifications</h3>
                      <ul className="qualifications-list">
                        <li>MSc. Food Science and Nutrition</li>
                        <li>Bsc. Food Nutrition and Dietetics</li>
                        <li>Diabetes Educator </li>
                        <li>900 hrs Advance teacher training yoga course </li>
                        <li>YCB Level 3 Yoga Instructor and Evaluator </li>
                        <li>Experience: 5+ years </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="profile-card">
                  <div className='dietician'>
                    <img src='https://nispand.s3.ap-south-1.amazonaws.com/Untitled-1.png' alt='' />
                  </div>
                  <div className="profile-details">
                    <h2 className="profile-name">Kreena Sanjay Nagda <br /> (Clinical Dietician)</h2>
                    <div className="profile-list">
                      <h3 className="profile-title">Qualifications</h3>
                      <ul className="qualifications-list">
                        <li>MSc Clinical Nutrition and Dietetics</li>
                        <li>Functional Nutritionist</li>
                        <li>Certified Diabetes Educator</li>
                        <li>Holistic Nutrition Coach</li>
                        <li>Experience: 2+ years </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="client-reviews-container">
            <h2 className="reviews-title">our <span className="highlightreview">Client Reviews</span></h2>

            <div className="slider-container">


              <div className="slider-wrapper">
                <div className="slider-track">
                  {reviews.map((review, index) => {
                    // Calculate the position relative to current
                    let position = index - currentIndex;

                    // Handle wrapping for the carousel effect
                    if (position < -1) position = reviews.length - Math.abs(position);
                    if (position > 1) position = position - reviews.length;

                    const isLongText = review.details.length > 150;
                    const isLongTitle = review.text.length > 150;

                    return (
                      
                      <div
                        key={index}
                        className={`slide ${position === 0 ? 'active' : position === -1 ? 'prev' : position === 1 ? 'next' : ''}`}
                      >
                        
                        <div className="card">
                          <h3>{isLongTitle ? (
                            <>
                             {review.text.slice(0, 300)} 
                             <span className="read-more" style={{ color: 'blue', cursor: 'pointer', fontSize: '20px'}} onClick={() => openModal(review)}> ...Read more</span>
                            </>
                          ) : (
                            review.text
                          )}</h3>
                          <p>
                          {isLongText ? (
                              <>
                                {review.details.slice(0, 150)} 
                                <span className="read-more" style={{ color: 'blue', cursor: 'pointer', fontSize: '20px'}}  onClick={() => openModal(review)}> ...Read more</span>
                              </>
                            ) : (
                              review.details
                          )}
                         
                          </p>
                        </div>
                       
                      </div>
                    );

                   
                  })}
                </div>
              </div>

              {showModal && selectedReview && (
        <MessageReview
          type={selectedReview.text}
          message={selectedReview.details}
          closePopup={closeModal}
          button="Close"
          buttonAction={closeModal}
        />
      )}

              

              {
                reviews.length > 1 && 
                  <div className="navigation">
                <button className="nav-btn prev-btn" onClick={prevSlide}>&#10094;</button>
                <div className="pagination">
                  {reviews.map((_, index) => (
                    <div
                      key={index}
                      className={`pagination-dot ${index === currentIndex ? 'active' : ''}`}
                      onClick={() => goToSlide(index)}
                    />
                  ))}
                </div>
                <button className="nav-btn next-btn" onClick={nextSlide}>&#10095;</button>
                </div>
              
              }
              

            </div>

          </div>

          <div className='bg_wrapper_client'>
            <div className="client-wave">
              <img src={greenbackground} alt="Wave background" />
            </div>
          </div>



          <div className="social-proof-container">
            <h2 className="social-proof-title">our <span className="highlight">Social Proof</span></h2>



            <div className="social-proof-card">
              <img src={footericon} alt="" className='footericon' />
              <div className="social-proof-content">

                <h3 className="social-proof-heading">Fuel Your Body, Transform Your Life</h3>
                <p className="social-proof-text">Science-backed nutrition tailored to your lifestyle. Start your journey today.</p>
                <div className="social-icons">
                  <a href="https://www.facebook.com/share/18ew37fDqZ/ " className="social-icon facebook">

                    <img src={fb} alt="" />

                  </a>
                  <a href=" https://www.instagram.com/nutridietclinicofficial/ " className="social-icon instagram">

                    <img src={insta} alt="" />

                  </a>
                </div>
              </div>
              <div className="badges">
                <div className="badge">
                </div>
              </div>
            </div>
          </div>

          {/* Floating Health Journey Section */}
          {/* <div className={`health-journey-container ${isFloating ? 'floating' : ''}`}>
            <h2 className="journey-title">Start Your Personalized Health Journey!</h2>

            <div
              id="date-select-mobile"
              style={{ display: 'flex', alignItems: 'center' }}
              className='select_wrapper'
            >
              <div className='fixes_mobile'>
                <SelectDropDown
                  currentValue={plan}
                  changeCurrentValue={setPlan}
                  text={'Select Package'}
                  isStyles={selectStyles1}
                  dates={options}
                />{' '}
                <SelectDropDown
                  currentValue={program}
                  changeCurrentValue={setProgram}
                  text={'Select Program'}
                  isStyles={selectStyles1}
                  dates={options1}
                />
              </div>
              <div className="btn_enroll">
                <CommonBtn text='Enroll Now' buttonAction={belowEnrollFrom} />
              </div>
              <div style={{ justifyContent: 'end', display: 'flex', margin: '10px', color: '#FF3B30', fontSize:'14px', fontWeight:'600', }}>
                {err && <small> Please select package/program* </small>}
              </div>

            </div>
          </div> */}

<div class={`card1 ${isFloating ? 'floating' : ''}`}>
<h2 >Start Your Personalized Health Journey!</h2>
    
        <div
              id="date-select-mobile"
              style={{ display: 'flex' }}
              className='select_wrapper'
            >
              <div className='fixes_mobile' style={{ display: 'flex', alignItems: 'center' }}>
                <select
                  value={selectedCurrency}
                  onChange={e => setSelectedCurrency(e.target.value)}
                  style={{ 
                    ...selectStyles1, 
                    minWidth: '90px', 
                    marginRight: '10px', 
                    color: '#fff', 
                    background: 'rgba(255, 255, 254, 0.3)', 
                    padding: '8px',
                    '& option': {
                      backgroundColor: '#000',
                      color: '#fff'
                    }
                  }}
                  className="currency-dropdown"
                >
                  {currencyOptions.map(option => (
                    <option key={option} value={option} style={{ backgroundColor: '#000', color: '#fff' }}>{option}</option>
                  ))}
                </select>
                <SelectDropDown
                  currentValue={plan}
                  changeCurrentValue={setPlan}
                  text={'Select Package'}
                  isStyles={selectStyles1}
                  dates={options}
                />{' '}
                <SelectDropDown
                  currentValue={program}
                  changeCurrentValue={setProgram}
                  text={'Select Program'}
                  isStyles={selectStyles1}
                  dates={programOptions}
                />
              </div>
                <div className="btn_enroll">
                  <CommonBtn text='Enroll Now' buttonAction={belowEnrollFrom} />
                </div>
              <div style={{ justifyContent: 'end', display: 'flex', margin: '0px', color: '#FF3B30', fontSize:'14px', fontWeight:'600', }}>
                {err && <small> Please select package/program* </small>}
              </div>
              </div>

            </div>

          {openForm2 && <SubcriptionForm packageName={plan} selectedPackageName={program} packagePrice={calculatePrice(plan, program, selectedCurrency === 'Living in India' ? 'INR' : 'USD')} currency={selectedCurrency} closeForm={setOpenForm2} />}

        </div>
      </div>
    </div>
  );
};

export default NutriDietHero;